import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  qrCodeImage: {
    width: 280,
    height: 280,
    backgroundColor: colors.backgroundPrimary,
    borderRadius: theme.borderRadius.m,
    padding: theme.spacing[4],
    marginBottom: theme.spacing[6],
    shadowColor: colors.borderPrimary,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
  },
  retryButton: {
    width: '50%',
  },
}));
